import { COLORS } from '../utils/colors';

const navigationItems = [
  { id: 'hero', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'approach', label: 'Approach' },
  { id: 'engagement', label: 'Services' },
  { id: 'outcomes', label: 'Results' },
  { id: 'stories', label: 'Case Studies' },
  { id: 'nonprofit', label: 'Non Profits' },
  { id: 'testimonials', label: 'Testimonials' },
  { id: 'contact', label: 'Contact' }
];

export const Navbar = ({ activeSection, scrollToSection, mobileMenuOpen, setMobileMenuOpen }) => (
  <nav 
    className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
    style={{
      backgroundColor: 'rgba(255,255,255,0.95)',
      backdropFilter: 'blur(12px)',
      borderBottom: '1px solid #E2E8F0',
      boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
    }}
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20">
      <div className="flex items-center justify-between h-16">
        <div className="hidden md:flex space-x-8 mx-auto">
          {navigationItems.map(item => (
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className="px-3 py-2 rounded-lg font-medium transition-all duration-300"
              style={{
                color: activeSection === item.id ? COLORS.cantaloupe : COLORS.slate,
                backgroundColor: activeSection === item.id ? 'rgba(255,130,67,0.1)' : 'transparent',
                position: 'relative'
              }}
            >
              {item.label}
              {activeSection === item.id && (
                <span 
                  className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-5 h-0.5 rounded-full"
                  style={{ backgroundColor: COLORS.cantaloupe }}
                ></span>
              )}
            </button>
          ))}
        </div>

        <div className="md:hidden w-full">
          <button
            className="p-2 rounded-lg transition-colors"
            style={{ backgroundColor: '#F1F5F9' }}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <div className="w-6 h-6 flex flex-col justify-center space-y-1">
              <div className={`w-full h-0.5 transition-all duration-300 ${mobileMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`} style={{ backgroundColor: COLORS.navy }}></div>
              <div className={`w-full h-0.5 transition-all duration-300 ${mobileMenuOpen ? 'opacity-0' : ''}`} style={{ backgroundColor: COLORS.navy }}></div>
              <div className={`w-full h-0.5 transition-all duration-300 ${mobileMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`} style={{ backgroundColor: COLORS.navy }}></div>
            </div>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div 
          className="md:hidden backdrop-blur-xl"
          style={{
            backgroundColor: 'rgba(255,255,255,0.98)',
            borderTop: '1px solid #E2E8F0'
          }}
        >
          <div className="px-4 py-6 space-y-2">
            {navigationItems.map(item => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="block w-full text-left px-4 py-3 rounded-lg transition-all duration-200"
                style={{
                  backgroundColor: activeSection === item.id ? COLORS.cantaloupe : 'transparent',
                  color: activeSection === item.id ? 'white' : COLORS.slate
                }}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  </nav>
);
